import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';
import { RightOutlined } from '@ant-design/icons';
import BindMobileModal from './BindMobileModal';
import styles from './BindMobileBanner.module.less';

const cx = classNames.bind(styles);

export const BindMobileBanner = () => {
  const ref = useRef<ModalRef>(null);
  const { t } = useTranslation();

  return (
    <div className={cx('banner-wrapper')}>
      <div className={cx('banner-content')}>
        <div>{t('account.bindMobileSuggestion')}</div>
        <div style={{ cursor: 'pointer' }} onClick={() => ref.current?.showModal()}>
          {t('account.bindNow')}
          <RightOutlined className={cx('bind-icon')} />
        </div>
      </div>
      <BindMobileModal ref={ref} />
    </div>
  );
};

export default BindMobileBanner;
